module.exports = __webpack_public_path__ + "img/trash-black.fc2ecc2c.svg";